module.exports = require('./assign');



//////////////////
// WEBPACK FOOTER
// ../~/velocity-react/~/lodash/object/extend.js
// module id = 607
// module chunks = 0